export const pdpEventsConfig = {
    parentSelector: '[id*="MainProduct-template"]',
    events: {
        thumbnailSlider: {
            selector: '.thumbnail',
            events: {
                click: {
                    event: 'pdp',
                    component: 'thumbnail_slider',
                    element: 'image',
                    action: 'click',
                    trigger: 'click',
                    getDynamicData: (element) => {
                        const mediaId = element.getAttribute('data-media-id');
                        return {
                            media_id: mediaId
                        };
                    }
                },
            }
        },
        // Added events for thumbnail slider arrows
        thumbnailSliderArrows: {
            parentSelector: '.slider-buttons', // More specific parent for the buttons
            selector: '.slider-button', // General selector for both buttons
            events: {
                previous: {
                    selector: '.slider-button--prev', // Specific selector for previous
                    event: 'pdp',
                    component: 'thumbnail_slider',
                    element: 'chevron',
                    action: 'click',
                    trigger: 'click',
                    action_value: 'previous' // Specific action value
                },
                next: {
                    selector: '.slider-button--next', // Specific selector for next
                    event: 'pdp',
                    component: 'thumbnail_slider',
                    element: 'chevron',
                    action: 'click',
                    trigger: 'click',
                    action_value: 'next' // Specific action value
                }
            }
        },
        imageModal: {
            events: {
                open: {
                    selector: '.product__media-toggle',
                    event: 'pdp',
                    component: 'image_modal',
                    element: 'modal',
                    action: 'open',
                    trigger: 'click',
                    getDynamicData: (element) => {
                        const mediaId = element.getAttribute('data-media-id');
                        return {
                            media_id: mediaId
                        };
                    }
                },
                close: {
                    selector: 'button.product-media-modal__toggle',
                    event: 'pdp',
                    component: 'image_modal',
                    element: 'modal',
                    action: 'close',
                    trigger: 'click'
                }
            }
        },
        productConfiguration: {
            selector: '.badge.badge--primary, .badge.badge--primary a',
            events: {
                click: {
                    event: 'pdp',
                    component: 'product_configuration',
                    element: 'button',
                    action: 'click',
                    trigger: 'click',
                    getDynamicData: (element) => {
                        // Get the parent span if the clicked element is the anchor
                        const parentSpan = element.closest('.badge.badge--primary');
                        const link = element.tagName === 'A' ? element : element.querySelector('a');
                        return {
                            action_value: parentSpan.textContent.trim(),
                            link_url: link ? link.href : ''
                        };
                    }
                }
            }
        },
        addToCart: {
            selector: 'form.form[id*="product-form-"]',
            event: {
                event: 'pdp',
                component: 'product_configuration',
                element: 'cta_button',
                action: 'click',
                trigger: 'submit',
                getDynamicData: (element) => {
                    const productTitle = document.querySelector('.product__title h1')?.textContent.trim() || '';
                    const submitButton = element.querySelector('.product-form__submit');
                    const clickText = submitButton ? submitButton.textContent.trim() : 'Add to cart';
                    return {
                        action_value: clickText,
                        product_name: productTitle
                    };
                }
            }
        },
        informationModal: {
            selector: '.pickup-availability-button',
            events: {
                open: {
                    event: 'pdp',
                    component: 'information_modal',
                    element: 'modal',
                    action: 'open',
                    trigger: 'click',
                    getDynamicData: (element) => ({
                        field: element.textContent.trim(),
                        field_name: element.textContent.trim()
                    })
                },
                close: {
                    selector: 'svg.icon.icon-close',
                    event: 'pdp',
                    component: 'information_modal',
                    element: 'modal',
                    action: 'close',
                    trigger: 'click',
                    getDynamicData: (element) => ({
                        field_name: element.textContent.trim()
                    })
                }
            }
        },
        // TODO: Add usage instructions events
        // usageInstructions: {
        //     selector: '.custom-usage-instructions',
        //     events: {
        //         modalOpen: {
        //             selector: '.usage-instructions__modal-trigger',
        //             event: 'pdp',
        //             component: 'usage_instructions',
        //             element: 'modal',
        //             action: 'open',
        //             trigger: 'click'
        //         },
        //         modalClose: {
        //             selector: '.modal__close-button',
        //             event: 'pdp',
        //             component: 'usage_instructions',
        //             element: 'modal',
        //             action: 'close',
        //             trigger: 'click'
        //         },
        //         accordionOpen: {
        //             selector: '.accordion__summary',
        //             event: 'pdp',
        //             component: 'usage_instructions',
        //             element: 'accordion',
        //             action: 'open',
        //             trigger: 'click',
        //             getDynamicData: (element) => ({
        //                 field_name: element.textContent.trim()
        //             })
        //         },
        //         accordionClose: {
        //             selector: '.accordion__summary',
        //             event: 'pdp',
        //             component: 'usage_instructions',
        //             element: 'accordion',
        //             action: 'close',
        //             trigger: 'click',
        //             getDynamicData: (element) => ({
        //                 field_name: element.textContent.trim()
        //             })
        //         },
        //         download: {
        //             selector: '.usage-instructions__download',
        //             event: 'pdp',
        //             component: 'usage_instructions',
        //             element: 'link',
        //             action: 'click',
        //             trigger: 'click',
        //             getDynamicData: (element) => ({
        //                 action_value: element.textContent.trim()
        //             })
        //         }
        //     }
        // },
        // ctaButtons: {
        //     selector: '.banner__buttons .button',
        //     event: {
        //         event: 'pdp',
        //         component: 'cta_button',
        //         element: 'cta_button',
        //         action: 'click',
        //         trigger: 'click',
        //         getDynamicData: (element) => ({
        //             action_value: element.textContent.trim(),
        //             product_name: document.querySelector('h1.product__title')?.textContent.trim() || '',
        //             link_url: element.href
        //         })
        //     }
        // }
    }
}; 